import { Component, OnInit } from '@angular/core';
import { Company } from '../../../../models/company';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../../services/auth.service';
import { Audit_Log } from '../../../../models/audit_log';
import { ManagedCylinderInformationService } from '../../../../services/managed-cylinder-information.service';
import { ManagedCylinderInformation } from '../../../../models/managed-cyllinder-information';
import { ProductTypeService } from '../../../../services/product-type.service';
import { CylinderSizeService } from '../../../../services/cylinder-size.service';

@Component({
  selector: 'app-managed-cylinder-information-manage',
  templateUrl: './managed-cylinder-information-manage.component.html',
  styleUrls: ['./managed-cylinder-information-manage.component.css']
})
export class ManagedCylinderInformationManageComponent implements OnInit {
  companies: Company[] = [];
  managedCylinderInformation: ManagedCylinderInformation = new ManagedCylinderInformation();
  client;
  productTypes = [];
  cylinderSizes = [];
  address1: string = '';

  constructor(
    private authService: AuthService,
    private managedCylinderInformationService: ManagedCylinderInformationService,
    private productTypeService: ProductTypeService,
    private cylinderSizeService: CylinderSizeService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.client = this.authService.currentUser.value;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const id = params['managedCylinderInfoId'];
      const locationId = +params['locationId'];
      this.address1 = params['address1'] || '';

      
      if (id) {
        this.managedCylinderInformationService.get(id).then(data => {
          this.managedCylinderInformation = data;
          this.managedCylinderInformation.is_Edit = true;
        });
      }

      if (locationId) {
        this.managedCylinderInformation.location_Id = locationId;
      }
    });

    this.loadProductTypes();
    this.loadCylinderSizes();
  }

  loadProductTypes() {
    this.productTypeService.getAll().then(data => {
      this.productTypes = data;
    });
  }

  loadCylinderSizes() {
    this.cylinderSizeService.getAll().then(data => {
      this.cylinderSizes = data;
    });
  }


  submit() {
    if (!this.validateNumericFields()) {
      alert("Please enter valid numeric values.");
      return;
    }

    if (this.isMinGreaterThanTarget()) {
      alert("Minimum cannot be greater than Target");
      return;
    }

    this.managedCylinderInformation.target = Number(this.managedCylinderInformation.target);
    this.managedCylinderInformation.minimum = this.managedCylinderInformation.minimum ? Number(this.managedCylinderInformation.minimum) : 0;

    const dailyAverageCurrentValue = this.managedCylinderInformation.daily_Avg_Usage; 
    this.managedCylinderInformation.daily_Avg_Usage = dailyAverageCurrentValue === null || dailyAverageCurrentValue === undefined ? '' : String(dailyAverageCurrentValue).trim();

    const log = new Audit_Log();
    log.entity = log.auditTypes.Managed_Cylinder_Info;
    log.entity_Id = this.managedCylinderInformation.location_Id;
    log.user_Id = this.client.userId;
    log.description = `${this.client.firstname} ${this.client.lastname}`;
    log.actionType = this.managedCylinderInformation.is_Edit ? log.actionTypes.UPDATE : log.actionTypes.INSERT;

    this.managedCylinderInformation.audit_Log = log;

    this.managedCylinderInformationService.save(this.managedCylinderInformation).then(() => {
      this.router.navigate(
        ['administration/managed-cylinder-information-management'],
        {
          queryParams: {
            locationId: this.managedCylinderInformation.location_Id,
            address1: this.address1
          }
        }
      );
    });
  }

  isMinGreaterThanTarget(): boolean {
    const target = Number(this.managedCylinderInformation.target);
    const minimum = Number(this.managedCylinderInformation.minimum);
    if (
      !isNaN(target) &&
      !isNaN(minimum) &&
      this.managedCylinderInformation.minimum !== '' &&
      minimum > target
    ) {
      return true;
    }
    return false;
  }

  validateNumericFields(): boolean {
    const target = this.managedCylinderInformation.target;
    const dailyAverage = this.managedCylinderInformation.daily_Avg_Usage;
    const minimum = this.managedCylinderInformation.minimum;

    const regex = /^[0-9]*$/;

    if (!target || !regex.test(String(target))) return false;
    if (dailyAverage != null && !regex.test(String(dailyAverage))) return false;
    if (minimum != null && !regex.test(String(minimum))) return false;

    return true;
  }
}
